export function ModeButton({ active, onClick, icon, text }: any) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-center gap-2 px-4 py-3 rounded-2xl border transition ${
        active ? "bg-cyan-500 text-white border-cyan-500" : "border-slate-950 text-gray-500"
      }`}
    >
      {icon} {text}
    </button>
  );
}
